import script from "./TheProductSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./TheProductSearch.vue?vue&type=script&setup=true&lang=js"

import "./TheProductSearch.vue?vue&type=style&index=0&id=6cbebb24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cbebb24"]])

export default __exports__